import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBell, faSignOut, faHeadset, faEllipsis, faClock, faRobot, faUpload } from "@fortawesome/free-solid-svg-icons";
import { faBell as faBellRegular } from "@fortawesome/free-regular-svg-icons";
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import NotificationAPI from '~/api/notificationsApi';
import {useUserAvatar} from '~/pages/context/UserAvatarContext';
import {usePlanFeature} from '~/pages/context/PlanFeatureContext';
import {Fragment, useEffect, useState} from "react";
import {format} from "date-fns";
import {CenteredModal} from "~/components";
const apiUrl = process.env.REACT_APP_API_URL;
function HeaderAIChatbot() {
    const navigate = useNavigate();
    const { userAvatar } = useUserAvatar();
    const [notiCount, setNotiCount] = useState(0);
    const [notis, setNotis] = useState([]);
    const {getImageUrlById} = useAssetsImage();
    const {planFeature} = usePlanFeature();
    const [showModalBlockFeature, setShowModalBlockFeature] = useState(false);
    const [showModalSupportLocked, setShowModalSupportLocked] = useState(false);
    const logo = getImageUrlById(39);
    const emptyAvatar = getImageUrlById(63);
    const handleLogout = (e) => {
        e.preventDefault();
        axios.post(`${apiUrl}/api/auth/sign-out`, {}, {
            withCredentials: true
        })
            .then((res) => {
                if(res.data.Succeeded){
                    navigate("/auth/signin", { replace: true });
                }
            })
            .catch((err) => {
            })
    }

    useEffect(() => {
        NotificationAPI.getByUserId(0)
            .then((res) => {
                setNotiCount(res.data.length);
                setNotis(res.data);
            })
            .catch((err) => {
            })
    }, [])

    const shortTimeAgo = (date) => {
        const seconds = Math.floor((new Date() - date) / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (seconds < 60) return "Just now";
        if (minutes < 60) return `${minutes}m ago`;
        if (hours < 24) return `${hours}h ago`;
        return `${days}d ago`;
    }

    const handleAccessChat = (e) => {
        if(planFeature.CurrentServicePlanId === 0){
            e.preventDefault();
            setShowModalBlockFeature(true);
        }
    }

    const handleAccessSupportCase = (e) => {
        if(!planFeature.CustomerSupport){
            e.preventDefault();
            setShowModalSupportLocked(true);
        }
    }

    return (
        <Fragment>
            <nav className="navbar navbar-top fixed-top navbar-expand" id="navbarDefault">
                <div className="collapse navbar-collapse justify-content-between">
                    <div className="navbar-logo">
                        <Link className="navbar-brand me-1 me-sm-3" to="/ai-chatbot">
                            {
                                logo &&
                                <img src={logo} alt="bt" width="50"/>
                            }
                        </Link>
                    </div>
                    <ul className="navbar-nav navbar-nav-icons flex-row">
                        <li className="nav-item dropdown">
                            <a className="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false" data-bs-auto-close="outside">
                                <FontAwesomeIcon icon={faBellRegular} className={`text-body fs-7 mt-1 ${ notiCount > 0 ? "bell-shake" : "" }`}/>
                                {
                                    notiCount > 0  && (
                                        <span className="badge bg-danger rounded-pill notification-badge position-absolute"
                                              style={{
                                                  left: "0px",
                                                  top: "10px",
                                                  boxShadow: '0 0 3px rgba(0,0,0,0.3)'
                                              }}>
                                      {notiCount}
                                    </span>
                                    )
                                }
                            </a>
                            <div className="dropdown-menu-end dropdown-menu notification-dropdown-menu py-0 shadow border navbar-dropdown-caret"
                                 id="navbarDropdownNotfication"
                                 aria-labelledby="navbarDropdownNotfication">
                                <div className="card position-relative border-0">
                                    <div className="card-header p-2">
                                        <div className="d-flex justify-content-between">
                                            <h5 className="text-body-emphasis mb-0">Notifications</h5>
                                            <button className="btn btn-link p-0 fs-9 fw-normal" type="button">Mark all as read
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="scrollbar-overlay" data-simplebar="init" style={{height: '27rem'}}>
                                            <div className="simplebar-wrapper" >
                                                <div className="simplebar-height-auto-observer-wrapper">
                                                    <div className="simplebar-height-auto-observer"></div>
                                                </div>
                                                <div className="simplebar-mask">
                                                    <div className="simplebar-offset">
                                                        <div className="simplebar-content-wrapper"  role="region" aria-label="scrollable content">
                                                            <div className="simplebar-content">
                                                                {
                                                                    notis.map((item, index) => (
                                                                        <div key={index} className="px-2 px-sm-3 py-3 notification-card position-relative read border-bottom bg-body">
                                                                            <div className="d-flex align-items-center justify-content-between position-relative">
                                                                                <div className="d-flex">
                                                                                    <div className="avatar avatar-m me-3">
                                                                                        {
                                                                                            logo &&
                                                                                            <img className="rounded-circle" src={logo} alt=""/>
                                                                                        }
                                                                                    </div>
                                                                                    <div className="flex-1 me-sm-3">
                                                                                        <h4 className="fs-9 text-body-emphasis">BreakThrough</h4>
                                                                                        <p className="fs-9 text-success mb-2 mb-sm-3 fw-bold">
                                                                                            {item.Content}
                                                                                            <span className="ms-2 text-body-quaternary fw-bold fs-10">{shortTimeAgo(new Date(item.CreatedAt))}</span>
                                                                                        </p>
                                                                                        <p className="text-body-secondary fs-9 mb-0">
                                                                                            <FontAwesomeIcon icon={faClock} className="me-1"/>
                                                                                            <span className="fw-bold">{format(item.CreatedAt, "hh:mm a")} </span>{format(item.CreatedAt, "MMMM d, yyyy")}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="dropdown notification-dropdown">
                                                                                    <button className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none"
                                                                                            type="button" data-bs-toggle="dropdown"
                                                                                            data-boundary="window" aria-haspopup="true"
                                                                                            aria-expanded="false"
                                                                                            data-bs-reference="parent">
                                                                                        <FontAwesomeIcon icon={faEllipsis} className="fs-10 text-body"/>
                                                                                    </button>
                                                                                    <div className="dropdown-menu py-2">
                                                                                        <a className="dropdown-item" href="#!">
                                                                                            Mark as unread
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simplebar-placeholder" style= {{width: '0px', height: '0px'}}></div>
                                            </div>
                                            <div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}>
                                                <div className="simplebar-scrollbar" style={{width: '0px', display: 'none'}}>

                                                </div>
                                            </div>
                                            <div className="simplebar-track simplebar-vertical" style={{visibility: 'hidden'}}>
                                                <div className="simplebar-scrollbar" style={{height: '0px', display: 'none', transform: 'translate3d(0px, 113px, 0px)'}}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer p-0 border-top border-translucent border-0">
                                        <div className="my-2 text-center fw-bold fs-10 text-body-tertiary text-opactity-85">
                                            <Link className="fw-bolder" to="/home">Notification history</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link lh-1 pe-0" id="navbarDropdownUser" href="#!"
                               role="button" data-bs-toggle="dropdown"
                               data-bs-auto-close="outside" aria-haspopup="true"
                               aria-expanded="false">
                                <div className="avatar avatar-l ">
                                    {
                                        emptyAvatar &&
                                        <img className="rounded-circle" src={userAvatar.AvatarUrl ? userAvatar.AvatarUrl : emptyAvatar} alt=""/>
                                    }
                                </div>
                            </a>
                            <div
                                className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border"
                                aria-labelledby="navbarDropdownUser">
                                <div className="card position-relative border-0">
                                    <div className="card-body p-0">
                                        <div className="text-center pt-4 pb-3">
                                            <div className="avatar avatar-xl ">
                                                {
                                                    emptyAvatar &&
                                                    <img className="rounded-circle " src={userAvatar.AvatarUrl ? userAvatar.AvatarUrl : emptyAvatar} alt=""/>
                                                }
                                            </div>
                                            <h6 className="mt-2 text-body-emphasis">{userAvatar.UserName}</h6>
                                            <h6 className="mt-2 text-body-emphasis">{userAvatar.Email}</h6>
                                            {
                                                !userAvatar.CurrentPlan ?
                                                (
                                                    <span> Unsubscriber </span>
                                                )
                                                :
                                                (
                                                    <Fragment>
                                                        <p className="mb-0"> {userAvatar.CurrentPlan} </p>
                                                        <p> <strong className="text-success">{userAvatar.DayRemaining} </strong> Days Remaining </p>
                                                    </Fragment>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="overflow-auto scrollbar">
                                        <ul className="nav d-flex flex-column mb-2 pb-1">
                                            <li className="nav-item">
                                                <Link className="nav-link px-3 d-block" to="/ai-chatbot/profile-settings">
                                                    <FontAwesomeIcon icon={faUser} className="me-2 text-body align-bottom"/>
                                                    <span>Profile</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">

                                                <Link onClick={handleAccessChat} className="nav-link px-3 d-block" to="/ai-chatbot/chat">
                                                    <FontAwesomeIcon icon={faRobot} className="me-2 text-body align-bottom"/>
                                                    <span>AI Chatbot</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link px-3 d-block" href="#!">
                                                    <FontAwesomeIcon icon={faBell} className="me-2 text-body align-bottom"/>
                                                    <span>Notification</span>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link px-3 d-block" to="/ai-chatbot/upgrade-plan">
                                                    <FontAwesomeIcon icon={faUpload} className="me-2 text-body align-bottom"/>
                                                    <span>Upgrade Plan </span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link onClick={handleAccessSupportCase} className="nav-link px-3 d-block" to="/ai-chatbot/support-case">
                                                    <FontAwesomeIcon icon={faHeadset} className="me-2 text-body align-bottom"/>
                                                    <span>Support Case</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-footer p-0 border-0">
                                        <div className="px-3">
                                            <button className="btn btn-bt-secondary d-flex flex-center w-100" onClick={handleLogout}>
                                                <FontAwesomeIcon icon={faSignOut} className="me-2 text-body align-bottom"/>
                                                Sign out</button>
                                        </div>
                                        <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
                                            <Link className="text-body-quaternary me-1" to="/home">Privacy policy</Link>
                                            •<Link className="text-body-quaternary mx-1" to='/home'>Terms</Link>
                                            •<Link className="text-body-quaternary ms-1" to='/home'>Cookies</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
            <CenteredModal
                show={showModalBlockFeature}
                title="Upgrade Required"
                onClose={() => setShowModalBlockFeature(false)}
                closeText="Close"
            >
                <div className="text-center">
                    <p className="fs-8-1 fw-bold mb-2">
                        <span className="text-dark">Your current plan does not include</span>
                        <span className="text-primary"> access to this feature.</span>
                    </p>

                    <p className="text-body-tertiary fs-8-1 mb-0">
                        For extended capabilities and enterprise-level tools,
                        <br/>please upgrade to a higher tier subscription.
                    </p>

                    <Link onClick={() => setShowModalBlockFeature(false)} to='/ai-chatbot/upgrade-plan' className="nav-link fs-9 mt-3 text-primary text-decoration-underline">
                        Upgrade Here
                    </Link>
                </div>
            </CenteredModal>
            <CenteredModal
                show={showModalSupportLocked}
                title="Support Case Locked"
                onClose={() => setShowModalSupportLocked(false)}
                closeText="Close"
            >
                <div className="text-center">
                    <p className="fs-8-1 fw-bold mb-2">
                        <span className="text-dark">Your current subscription does not provide</span>
                        <span className="text-primary"> access to Support Case Management.</span>
                    </p>

                    <p className="text-body-tertiary fs-8-1 mb-0">
                        To submit and manage support cases with prioritized assistance,
                        <br/>please upgrade to a higher tier with enterprise support features.
                    </p>
                    <Link onClick={() => setShowModalSupportLocked(false)} to='/ai-chatbot/upgrade-plan' className="nav-link fs-9 mt-3 text-primary text-decoration-underline">
                        Upgrade Here
                    </Link>
                </div>
            </CenteredModal>

        </Fragment>
    )
}

export default HeaderAIChatbot;